/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} EnterpriseInputs */

const en_enterprise = /** @type {(inputs: EnterpriseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enterprise`)
};

const es_enterprise = /** @type {(inputs: EnterpriseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Empresarial`)
};

/**
* | output |
* | --- |
* | "Enterprise" |
*
* @param {EnterpriseInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const enterprise = /** @type {((inputs?: EnterpriseInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<EnterpriseInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enterprise(inputs)
	return es_enterprise(inputs)
});